export default __webpack_public_path__ + "static/chart_challenged-aef0230de1cf7ea4f0c5027fca69b299.svg";